module.exports = "/_next/static/images/HipaaCompliantBadge@2x-0367edd9c30305e30b6e64fe1581f0ff.png";